import { useAuth } from '@/features/auth';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading, state } = useAuth();
  const location = useLocation();

  // Wait for auth initialization to complete before deciding to redirect
  // state is undefined during initial load, becomes 'loggedin' or 'loggedout' after
  if (loading || state === undefined) {
    return null;
  }

  if (!user) {
    return <Navigate to='/auth/login' state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
